<template>
  <div class='button_div'>
    <button class="" @click="view('View')">檢視</button>
    <button :class="{ disabled_btn: isDisabled.edit, btn2: !isDisabled.edit }" :disabled="isDisabled.edit" @click="view('Edit')">編輯</button>
    <button :class="{ disabled_btn: isDisabled.process, btn3: !isDisabled.process }" :disabled="isDisabled.process" @click="view('Process')">送修</button>
    <button :class="{ disabled_btn: isDisabled.return, btn4: !isDisabled.return }" :disabled="isDisabled.return" @click="view('Return')">歸還</button>
  </div>
</template>

<script>
  // import router from '@/router';
  import {
    onMounted,
    ref
  } from 'vue';
  import {
    useRouter
  } from 'vue-router';
  import { 
    Repair_Edit_Status ,
    Repair_Process_Status,
    Repair_Return_Status, 
  } from '@/assets/js/enter_status';
  export default {
    props: ['params'],
    setup(props) {
      const router = useRouter();
      const search_id = props.params.data.RepairId;
      const disabledStatus = props.params.data.Status;
      const isDisabled = ref({
        edit: false, //編輯
        process: false, //送修
        return: false, //歸還
      })
      function view(type) {
        if (search_id !== '') {
          switch (type) {
            case 'View':
              router.push({
                name: 'Repair_View',
                query: {
                  search_id
                }
              });
              break;
            case 'Edit':
              router.push({
                name: 'Repair_Edit',
                query: {
                  search_id
                }
              });
              break;
            case 'Process':
              router.push({
                name: 'Repair_Process',
                query: {
                  search_id
                }
              });
              break;
            case 'Return':
              router.push({
                name: 'Repair_Return',
                query: {
                  search_id
                }
              });
              break;

          }
        }
      }
      function checkButton() {
        // console.log(disabledStatus);
        if (!Repair_Edit_Status.includes(disabledStatus)) {
          isDisabled.value.edit = true;
        }
        if (!Repair_Process_Status.includes(disabledStatus)) {
          isDisabled.value.process = true;
        }
        if (!Repair_Return_Status.includes(disabledStatus)) {
          isDisabled.value.return = true;
        }
      }

      onMounted(() => {
        checkButton();
      });
      return {
        view,
        disabledStatus,
        isDisabled,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/global.scss';
  .button_div {
    justify-content: center;
     :nth-child(1) {
      @include datagrid_view_button;
      height: 25px;
      &:hover {
        background: #1D7072;
        color: white
      }
    }
    .btn2 {
      @include datagrid_edit_button;
      height: 25px;
      &:hover {
        background: #3B6162;
        color: white
      }
    }
    .btn3 {
      @include datagrid_inform_button;
      height: 25px;
      width: 50px;
      &:hover {
        background: #64a1a3;
        color: white
      }
    }
    .btn4 {
      @include datagrid_pass_button;
      height: 25px;
      &:hover {
        background: #597c7c;
        color: white
      }
    }
    .btn5 {
      @include datagrid_result_button;
      height: 25px;
      &:hover {
        background: #1D7072;
        color: white
      }
    }
    .disabled_btn {
      @include disabled_btn;
      height: 25px;
      width: 50px;
       :hover {
        @include disabled_btn;
        width: 50px;
      }
    }
  }
</style>